import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"label":_vm.$t('Type'),"items":_vm.items,"outlined":"","multiple":"","hide-details":"auto"},model:{value:(_vm.subsetValue),callback:function ($$v) {_vm.subsetValue=$$v},expression:"subsetValue"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }